export const StatutsChantier = {
  PREPARATION_TRAVAUX: 'Préparation travaux',
  TRAVAUX_EN_COURS: 'Travaux en cours',
  OUVRAGE_ELECTRIQUE_CONSTRUIT: 'Ouvrage électrique construit',
  CHANTIER_ET_TRAVAUX_TERMINES: 'Chantiers et travaux terminés',
};
